export default function YouTubeIcon({ socialIconClass }) {
  return (
    // <svg
    //   className={socialIconClass}
    //   id='YouTube'
    //   xmlns='http://www.w3.org/2000/svg'
    //   width='34.82'
    //   height='34.82'
    //   viewBox='0 0 34.82 34.82'>
    //   <path
    //     id='Path_23'
    //     data-name='Path 23'
    //     d='M34.82,17.41A17.41,17.41,0,1,1,17.41,0,17.41,17.41,0,0,1,34.82,17.41'
    //     fill='#fff'
    //   />
    //   <path
    //     id='Path_24'
    //     data-name='Path 24'
    //     d='M41.559,33.148a83.584,83.584,0,0,0-16.351,0,3,3,0,0,0-3,3v9.459a3,3,0,0,0,3,3,83.538,83.538,0,0,0,16.351,0,3,3,0,0,0,3-3V36.15a3,3,0,0,0-3-3M30.389,44.415V37.343l5.989,3.823Z'
    //     transform='translate(-15.973 -23.556)'
    //     fill='#2572a2'
    //   />
    // </svg>
    <svg className={socialIconClass} viewBox='0 0 58.23 58.23'>
      <g id='YouTube'>
        <path
          fill='#fff'
          d='M29.12,0C13.04,0,0,13.04,0,29.12s13.04,29.12,29.12,29.12,29.12-13.04,29.12-29.12S45.2,0,29.12,0Zm17.55,36.18c-.56,4.18-2.65,4.81-6.76,5.16-3.56,.35-7.6,.42-10.74,.42s-7.25-.07-10.74-.42c-4.11-.35-6.28-.98-6.83-5.16-.21-1.81-.35-4.46-.35-7.11s.14-5.23,.35-7.11c.56-4.11,2.72-4.81,6.83-5.16,3.49-.28,7.6-.42,10.74-.42s7.18,.14,10.74,.42c4.11,.35,6.21,1.05,6.76,5.16,.28,1.88,.42,4.46,.42,7.11s-.14,5.3-.42,7.11Z'
        />
        <polygon
          fill='#fff'
          points='25.54 23.7 34.88 29.07 25.54 34.51 25.54 23.7'
        />
      </g>
    </svg>
  );
}
